import { observer } from 'mobx-react-lite'
import { JobEvent } from '@/features/jobs/details/components/EventsCard/JobEvent'
import { type JobEvent as JobEventModel } from '@/features/jobs/JobEvent'
import {
  formatJobEventDescription,
  formatJobEventTestId,
} from '@/features/jobs/details/job-event-formatters'

export interface JobEventContainerProps {
  event: JobEventModel
  compact?: boolean
}

export const JobEventContainer = observer(function JobEventContainer({
  event,
  compact,
}: JobEventContainerProps) {
  return (
    <JobEvent
      compact={compact}
      event={{
        triggeredBy: {
          avatar: event.triggeredBy.avatar,
          avatarFallback: event.triggeredBy.avatarFallback,
          displayName: event.triggeredBy.displayName,
        },
        descriptionParts: formatJobEventDescription(event),
        isTaskUpdate:
          event.eventType === 'TaskMarkedComplete' ||
          event.eventType === 'TaskMarkedIncomplete',
        dateCreated: event.dateCreated,
        reason: event.reason,
      }}
      testId={formatJobEventTestId(event)}
    />
  )
})
